(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-app/assets/javascripts/behaviors/load-module-component.js') >= 0) return;  svs.modules.push('/components/numbergames/game-app/assets/javascripts/behaviors/load-module-component.js');

'use strict';

svs.numbergames.game_app.behaviors.LoadModuleComponent = Marionette.Behavior.extend({
  initialize() {
    var _svs$toNameSpace$comp;
    const toNameSpace = str => {
      var _str$replaceAll, _str$replaceAll2;
      return (_str$replaceAll = str === null || str === void 0 || (_str$replaceAll2 = str.replaceAll) === null || _str$replaceAll2 === void 0 ? void 0 : _str$replaceAll2.call(str, '-', '_')) !== null && _str$replaceAll !== void 0 ? _str$replaceAll : str;
    };
    if (this.options.component && this.options.module && svs[this.options.module] && !((_svs$toNameSpace$comp = svs[toNameSpace(this.options.module)].components) !== null && _svs$toNameSpace$comp !== void 0 && _svs$toNameSpace$comp[toNameSpace(this.options.component)])) {
      svs.ui.loader.show();
      svs.core.module.loadModuleComponent(this.options.component, () => {
        svs.ui.loader.hide();
        this.view.render();
      });
    }
  }
});

 })(window);